import React, { useRef } from 'react';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import { copyright, copyrightParams } from '../../../../constants/copyright';
import { safeHTML } from '../../../../utils/safeHTML';
import { useTranslation } from '../../../../translations';
import { useActions } from '../../../../hooks/components/pages/rules/useActions';

const RulesFooter = React.forwardRef(function (
  { isModal, closeModal, setActiveSlide, activeSlide, buttonText, changeState, rulesList },
  ref,
) {
  const { t } = useTranslation();
  const actions = useActions({ setActiveSlide, activeSlide, isModal, rulesList });

  const nextBtn = useRef();

  return (
    <>
      <CustomButton
        ref={nextBtn}
        className={'rules__button rules__button_next custom-button_show-anim'}
        sound={'onboarding'}
        text={buttonText}
        onClick={actions.nextRule}
      />

      <div className={'rules__copyright'}>{safeHTML(t(copyright, copyrightParams))}</div>
    </>
  );
});
export default RulesFooter;
RulesFooter.propTypes = {};
